import { Button, Form, Row, Space } from "antd";
import { InputFields } from "components/common";
import ModalResults from "components/common/ModalTable/ModalTable";
import React, { useEffect, useState } from "react";
import { fields } from "./config";
import consultantAndFragmentService from "api/consulantAndFragtment";
import Notification from "components/common/notification/notification";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { convertIosStringToDateDayjs } from "helper/common";
import { setDataConsultantAndFragment } from "redux/reducer/consultantAndFragment";
import { FORMAT_TIME } from "types/enums";
import dayjs from "dayjs";

type ModalDisAgreeProps = {
  isShowModalDisAgree: any;
  setIsShowModalDisAgree: any;
  id?: number | string;
};

const ModalDisAgree = ({
  isShowModalDisAgree,
  setIsShowModalDisAgree,
}: ModalDisAgreeProps) => {
  const handleCancel = () => {
    setIsShowModalDisAgree(false);
  };
  const idConsultantInfo = useAppSelector(
    (e) => e.consultantAndFragment.idConsultantInfo
  );
  const [form] = Form.useForm();
  const id = useAppSelector(
    (e) => e.consultantAndFragment.idConsultantAndFragment
  );
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();

  const updateSurgeryAgree = async (method, data) => {
    const res = await consultantAndFragmentService[method](data);
    const newData = await res?.lichSuTuVanDtos?.map((item) => ({
      ...item,
      key: item.id,
    }));

    dispatch(setDataConsultantAndFragment({ ...res, ...newData }));
    setIsShowModalDisAgree({
      type: "old",
      isShow: false,
    });
  };

  const handleSubmit = async () => {
    form.validateFields().then((value) => {
      const newValue = {
        type: 0,
        ...value,
        idPhieuTuVan: id,
        id: idConsultantInfo,
        thoiGianHenGoiLai: value.thoiGianHenGoiLai
          ? dayjs(value.thoiGianHenGoiLai).format(FORMAT_TIME.timeDetail)
          : null,
      };
      if (isShowModalDisAgree.type === "new") {
        updateSurgeryAgree("postSurgeryDisagree", newValue);
      } else {
        updateSurgeryAgree("putSurgeryDisagree", newValue);
      }
    });
  };

  const getListReason = async () => {
    try {
      const res = await consultantAndFragmentService.getListReason();

      fields.find((e) => e.name === "lyDoTuChoi").options = res.map((e) => {
        return { value: e.id, label: e.tenLyDoTuChoi };
      });

      setOpen(true);
    } catch (error) {
      if (isShowModalDisAgree.type) {
        Notification("error", "Đã xảy ra lỗi khi lấy danh sách lý do từ chối");
      }
    }
  };

  const getSurgeryAgree = async () => {
    try {
      const res = await consultantAndFragmentService.getSurgeryDisagree(
        idConsultantInfo
      );

      form.setFieldsValue({
        ...res,
        thoiGianHenGoiLai: convertIosStringToDateDayjs(res.thoiGianHenGoiLai),
      });
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi trong qúa trình lấy dữ liệu");
    }
  };

  useEffect(() => {
    if (idConsultantInfo) {
      getSurgeryAgree();
    } else form.resetFields();
  }, [idConsultantInfo]);

  useEffect(() => {
    getListReason();
  }, []);

  useEffect(() => {
    if (isShowModalDisAgree.type === "new") {
      form.resetFields();
    }
  }, [isShowModalDisAgree]);

  return (
    open && (
      <ModalResults
        title={"Từ chối phẫu thuật"}
        isShowModal={isShowModalDisAgree.isShow}
        handleCancel={handleCancel}
        heightContent={160}
        minHeight={160}
      >
        <Form form={form}>
          <Row gutter={[16, 8]}>
            <InputFields data={fields} />
          </Row>
          <Row justify={"end"}>
            <Space style={{ marginTop: "10px" }}>
              <Button key="cancel" type="primary" danger onClick={handleCancel}>
                Huỷ bỏ
              </Button>

              <Button
                key="submit"
                type="primary"
                htmlType="submit"
                onClick={handleSubmit}
              >
                Lưu lại
              </Button>
            </Space>
          </Row>
        </Form>
      </ModalResults>
    )
  );
};

export default ModalDisAgree;
